import type { AccountKey } from 'owa-client-types';
import getGlobalSettingsAccountKey from './getGlobalSettingsAccountKey';

/**
 * An Accounts Apartment is a logical consistency boundary that spans multiple
 * browser contexts (tabs, windows, workers) within the same origin. Contexts
 * in the same apartment share the same set of configured Outlook accounts and
 * keep that state synchronized (e.g. via BroadcastChannel). Contexts in
 * different apartments must remain isolated. This is loosely analogous to the
 * concept of an apartment in COM to denote a state isolation boundary, but does not
 * imply any threading or execution affinity.
 *
 * The Accounts Apartment key identifies the apartment that a context is using.
 * Currently, the apartment membership is determined by the Global Settings Account:
 * contexts with the same GSA are in the same accounts apartment. Hence, the
 * Accounts Apartment key derives from the GSA account key. If we ever allow the
 * GSA designation to change within a session, we need to determine apartment
 * membership differently to be stable across GSA changes.
 */
export type AccountsApartmentKey = AccountKey;

export function getAccountsApartmentKey(): AccountsApartmentKey {
    return getGlobalSettingsAccountKey();
}
